export const ActivationMailSentModalComponent = {
    template: require('./activation-mail-sent-modal.html'),
    controller: class ActivationMailSentModalComponent {
        private close: any;

        ok() {
            this.close();
        }
    },
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/login/activation-mail-sent-modal/activation-mail-sent-modal.component.ts